//@ts-check
import {Modal, Toggle} from '@/components/atoms'
import {SegmentModal} from '@/containers/Promotions/components/SegmentModal/SegmentModal'
import {SegmentGroup} from '@/containers/Promotions/components/SegmentSection/SegmentGroup'
import {useProductComboSegments} from '@/hooks/productCombo/useProductComboSegments'
import {Font} from 'pepsico-ds'
import {useState} from 'react'

const defaultSegmentModalState = {
  show: false,
  type: '',
  isInclude: false,
}

export const ComboSegmentSection = () => {
  const {
    segmentConfiguration,
    handleAllCustomersToggle,
    handleExcludeToggle,
    isAllCustomers,
    isExcludeEnabled,
    handleSubmitSegments,
    handleRemove,
  } = useProductComboSegments()
  const [segmentModalState, setSegmentModalState] = useState(defaultSegmentModalState)
  const [showConfirmationModal, setShowConfirmationModal] = useState(false)
  const [pendingSegmentSubmission, setPendingSegmentSubmission] = useState(null)

  const handleSegmentSelection = (items, isInclude) => {
    const type = items?.[0]?.id
    if (!type) {
      return
    }
    setSegmentModalState({
      show: true,
      type,
      isInclude,
    })
  }

  const handleCloseSegmentModal = () => {
    setSegmentModalState(defaultSegmentModalState)
  }

  const hasExistingSegments = () => {
    const hasIncludedSegments = segmentConfiguration?.includedSegments && segmentConfiguration?.includedSegments?.length > 0
    const hasExcludedSegments = segmentConfiguration?.excludedSegment?.segments && segmentConfiguration?.excludedSegment?.segments?.length > 0
    return hasIncludedSegments || hasExcludedSegments
  }

  const handleSegmentSubmission = (args) => {
    // Only show confirmation modal if there are already existing segments being modified
    if (hasExistingSegments()) {
      setPendingSegmentSubmission(args)
      setShowConfirmationModal(true)
    } else {
      // First time configuration, no confirmation needed
      handleSubmitSegments(args)
    }
    handleCloseSegmentModal()
  }

  const handleConfirmSegmentChange = () => {
    if (pendingSegmentSubmission) {
      handleSubmitSegments(pendingSegmentSubmission)
      setShowConfirmationModal(false)
      setPendingSegmentSubmission(null)
    }
  }

  const handleCancelSegmentChange = () => {
    setShowConfirmationModal(false)
    setPendingSegmentSubmission(null)
  }

  const includedSegmentGroup = segmentConfiguration?.includedSegments?.[0] ?? null

  const existingSelection = isExcludeEnabled
    ? segmentConfiguration?.excludedSegment?.segments
    : includedSegmentGroup?.segments

  return (
    <>
      <Font variant="bold">Segments</Font>
      <Toggle
        updateValue={handleAllCustomersToggle}
        value={isAllCustomers}
        uiSchema={{size: 'small', label: 'All Customers'}}
      />
      {!isAllCustomers && (
        <SegmentGroup
          groupIndex={null}
          segmentGroup={includedSegmentGroup}
          onSegmentSelection={items => handleSegmentSelection(items, true)}
          handleRemove={handleRemove}
          tagsSeparator="OR"
          dropdownLabel={'Segments *'}
        />
      )}
      <div className="h-px bg-gray-600" />
      <Toggle
        disabled={!isAllCustomers}
        updateValue={handleExcludeToggle}
        value={isExcludeEnabled}
        uiSchema={{size: 'small', label: 'Exclude'}}
      />
      {isExcludeEnabled && (
        <SegmentGroup
          groupIndex={null}
          segmentGroup={segmentConfiguration?.excludedSegment}
          onSegmentSelection={items => handleSegmentSelection(items, false)}
          handleRemove={handleRemove}
          tagsSeparator="OR"
        />
      )}
      <SegmentModal
        key={`segment-modal-${segmentModalState.show}-${segmentModalState.type}`}
        show={segmentModalState.show}
        type={segmentModalState.type}
        groupIndex={segmentModalState.groupIndex}
        existingSelections={existingSelection ?? []}
        onSubmit={handleSegmentSubmission}
        onClose={handleCloseSegmentModal}
      />
      <Modal
        showModal={showConfirmationModal}
        title={"Changing the Customer Segment will reset the Product List"}
        text={"If you change the customer segment, the current product list in this combo will be cleared. Do you want to continue?"}
        primaryButtonText="Yes"
        secondaryButtonText="No"
        showSecondaryButton={true}
        classNameWrapper="min-h-80"
        onClickSecondaryButton={handleCancelSegmentChange}
        onClickPrimaryButton={handleConfirmSegmentChange}
        hideCloseButton={true}
      />
    </>
  )
}
